export default __webpack_public_path__ + "static/media/product-vector-3.5f04e01a.png";